<template>
  <div class="dropdown">
    <div class="dropdown-trigger" @click="showDropDown = !showDropDown">
      <label>{{label}} </label>
      <button class="button">
        <span>{{ showAlphabet ? $t('common.beginWith'): $t('common.select') }} <strong>{{modelLabel}}</strong> </span>
        <span class="icon is-small">
          <svg class="arrowDown">
            <use xlink:href="@/assets/sprite.svg#icon-chevron"></use>
          </svg>
        </span>
      </button>
    </div>
    <div class="dropdown-menu" v-show="showDropDown" role="menu">
      <template v-if="showAlphabet">
        <div class="dropdown-content letters" :class="{alphabet: showAlphabet}" >
          <template v-for="(item, index) in alphabet" :key="'dropdown' + index">
            <a class="dropdown-item" @click="changeValue(item)"
                :class="{selected: item === modelValue}">
              {{item}}
            </a>
          </template>
        </div>
      </template>
      <template v-else>
        <!-- only use label for value, for easy display. will get value when send request -->
        <div class="dropdown-content" :class="{alphabet: showAlphabet}" >
          <template  v-for="(item, index) in options" :key="'dropdown' + index">
            <a class="dropdown-item" @click="changeValue(item.label)"
              :class="{selected: item.value === modelValue}">
              {{item.label}}
            </a>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';
export default {
  name: 'drop-down',
  // components: {
  //   'vue-highcharts': Vue3Highcharts
  // },
  props: ['label', 'modelValue', 'showAlphabet', 'options'],
  emits: ['update:modelValue', 'filter:modelValue'],
  setup (props) {
    const showDropDown = ref(false);
    const modelLabel = ref(null);
    watch(() => props.modelValue, (newVal, oldVal) => {
      modelLabel.value = props.modelValue;
    });
    modelLabel.value = props.modelValue;

    const createArrayAtoZ = () => {
      return Array
        .apply(null, { length: 26 })
        .map((x, i) => String.fromCharCode(65 + i));
    }
    const alphabet = createArrayAtoZ();

    return {
      alphabet,
      showDropDown,
      modelLabel
    }
  },
  methods: {
    changeValue (value) {
      if (value !== this.modelValue) {
        this.$emit('update:modelValue', value) // previously was `this.$emit('input', title)`
        this.$emit('filter:modelValue', value) // previously was `this.$emit('input', title)`
        this.showDropDown = false;
      }
    }
  }
}
</script>
<style scoped>
.dropdown .dropdown-menu {
  display: block;
}
.dropdown-content.alphabet a {
  display: inline-block;
  padding: 5px;
}
.selected {
  color: rgb(228, 104, 21);
}
.dropdown-item {
  padding: 10px;
}
</style>
